import React, { useState, useEffect, useContext } from 'react';
import { AddressSearchContext } from '/src/App';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';



import './style.css';

const LabAnalysisDiscounts = ({ simulatorData }) => {

    const { portalData } = useContext(AddressSearchContext);
    const { icons, companies } = portalData;

    const { discounts } = simulatorData;

    const discountIds = discounts.discountIds || [];
    const discountNum = discounts.discountNum || 0;

    // Filter the companies to those with an id in the discountIds array
    const discountCompanies = companies.filter(company => discountIds.includes(company.id));

    // Collect the icons using the icon key from all discountCompanies
    const discountIconsArray = discountCompanies.map(company => icons[company.icon]);

    const discountsFoundText = `We've identified ${discountNum} discount${discountNum === 1 ? '' : 's'} from across the companies above that you might be eligible for if you complete these projects. Once you generate your plan, we'll walk through how to access discounts.`;

    const discountsNotFoundText = "We didn't see any discounts that you might be eligible for with these projects. In case we've missed something, when you generate a plan we'll walk you through how to uncover any discounts that may be hidden away."


    let discountsText = discountsFoundText;

    if (discountNum === 0) {
        discountsText = discountsNotFoundText;
    }

    return (
        <div className="lab-analysis-section-content-container">
            <h2 className="lab-analysis-section-title">Discounts That Can Be Leveraged</h2>
            <div className="lab-analysis-discounts-data-container">
                {/* <div className="lab-analysis-discounts-data-number-of-discounts-container">
                    <span className="lab-analysis-discounts-data-number-of-discounts-text">{discountNum}</span>
                </div>
                <CurlyBraceDivider direction="right" /> */}
                {(discountIconsArray && discountIconsArray.length > 0) && (
                    <div className="lab-analysis-discounts-data-discounts-container">
                        {discountIconsArray.map(icon => (
                            <div className="lab-analysis-discounts-data-discount-icon-container">
                                <img src={CreateCloudfrontUrl(icon)} alt={`Quoll discount icon for ${icon}`} />
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <p dangerouslySetInnerHTML={{ __html: discountsText }} className="lab-analysis-section-text text-align-center" />
        </div>
    )
}

export default LabAnalysisDiscounts;